import React, { ReactNode } from "react";
import ServiceContainer from "./ServiceContainer";
import { ServiceContainerContext } from "./ServiceContainerHooks";

interface ServiceContainerProviderProps {
  children: ReactNode;
  container?: ServiceContainer; // Optional for testing
}

/**
 * Provider component that makes ServiceContainer available to all child components
 */
export const ServiceContainerProvider: React.FC<
  ServiceContainerProviderProps
> = ({ children, container }) => {
  const serviceContainer = container || ServiceContainer.getInstance();

  return (
    <ServiceContainerContext.Provider value={serviceContainer}>
      {children}
    </ServiceContainerContext.Provider>
  );
};

export default ServiceContainerProvider;
